import decode from 'jwt-decode';
import { CHECK_MODULE_IS_ACTIVED } from '@betwixt/common/graphql/modules.js';
import { GET_INFOUSER, USER_WITH_TOKEN } from '@betwixt/common/graphql/user.js';
import { SetErrorsToState, SetError } from '@betwixt/common';

const readUserCache = (cache) => {
  try {
    return cache.readQuery({ query: GET_INFOUSER }) || null;
  } catch (err) {
    return null;
  }
};

const writeUserCache = (cache, incomingUser) => {
  const existingData = readUserCache(cache);
  const existingUser = existingData?.User || {};

  const data = {
    User: {
      ...existingUser,
      __typename: 'User',
      id: incomingUser.id,
      clientId: incomingUser.clientId,
      username: incomingUser.username,
      companyname: incomingUser.companyname,
      roles: incomingUser.roles,
      modulesActived: incomingUser.modulesActived,
      subscriptions: incomingUser.subscriptions,
    },
  };

  cache.writeQuery({ query: GET_INFOUSER, data });

  return data.User;
};

export const OAuth = {
  init: async (client, moduleId) => {
    /**
     * @param {string} client - this is client prop
     * @param {string} moduleId - this is moduleId
     * @return {object} result status ok: true|false
     */
    const tokenData = await OAuth.getTokenData();

    if (tokenData.ok) {
      if (moduleId && tokenData.clientId) {
        const thisModuleIsValid = await client
          .query({
            query: CHECK_MODULE_IS_ACTIVED,
            variables: { moduleId },
          })
          .then((res) => res.data.checkModuleIsActived);

        if (!thisModuleIsValid.ok) return thisModuleIsValid;
      }

      const user = await OAuth.setClientData(client, tokenData.clientId);

      if (!user) return { ok: false };

      return { ok: true };
    }

    return { ok: false };
  },

  getTokenData: async () => {
    const token = OAuth.getToken();
    const refreshToken = OAuth.getRefreshToken();

    if (!token || !refreshToken) {
      return { ok: false, clientId: null };
    }

    try {
      const { exp } = decode(refreshToken);

      var expDate = new Date(0);
      expDate.setUTCSeconds(exp);

      const isValid = expDate > new Date();

      if (!isValid) {
        return { ok: false, clientId: null };
      }
    } catch (err) {
      return { ok: false, clientId: null };
    }

    const decodedToken = decode(token);
    const tokenUser = decodedToken && decodedToken.user ? decodedToken.user : null;

    if (!tokenUser || !tokenUser.clientId) {
      return { ok: false, clientId: null };
    }

    return {
      ok: true,
      clientId: tokenUser.clientId,
      user: tokenUser,
      modulesActived: tokenUser.modulesActived || [],
    };
  },

  setClientData: async (client, clientId) => {
    try {
      const { data } = await client.mutate({
        mutation: USER_WITH_TOKEN,
        variables: {
          clientId,
        },
        /*
                  optimisticResponse: {
                      userFromToken: {
                          __typename: 'Mutation',
                          ok: true
                      }
                  },
                  */
        update: (store, { data: { userFromToken } }) => {
          if (userFromToken.ok) {
            const user = writeUserCache(store, userFromToken.user);

            return { _typename: user.__typename };
          }
        },
      });

      return data?.userFromToken?.ok
        ? data.userFromToken.user
        : readUserCache(client)?.User || null;
    } catch (err) {
      console.log(err);
    }
  },

  getToken: () => {
    return localStorage.getItem('token');
  },

  getRefreshToken: () => {
    return localStorage.getItem('refreshToken');
  },

  logout: async (client) => {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    location.href = '/login';

    if (client) await client.cache.gc();
  },

  automaticLogin: async ($this, flow) => {
    $this.props
      .mutate({
        variables: {
          username: $this.state.username,
          password: $this.state.password,
          flow: flow,
        },
        update: (store, { data: { login } }) => {
          if (login.ok) {
            const user = writeUserCache(store, login.user);

            return { _typename: user.__typename };
          }
        },
      })
      .then(async ({ data }) => {
        if (data.login.ok) {
          localStorage.setItem('token', data.login.token);
          localStorage.setItem('refreshToken', data.login.refreshToken);
          $this.props.history.push(
            `/${data.login.user.modulesActived[0].routes.my.path}${$this.props.location.search}`
          );
        } else {
          SetErrorsToState(data.login.errors, $this);
        }
      })
      .catch((err) => {
        SetError('inMODAL', 'Network error', err.message, $this.props.client, $this.props.history);
      });
  },
};
